import * as React from "react"
import {
  Dialog,
  DialogActions,
  DialogTitle,
} from "@material-ui/core"
import { PrimaryButton } from "@humanpredictiveintelligence/myqvt-library"
import { t } from "ttag"
import * as Styles from "./DeleteQuestionDialog.styles"

export const DeleteQuestionDialog: React.FC<DeleteQuestionDialogProps> = (props) => {
  return (
    <Dialog
      open
      onClose={props.onClose}
      maxWidth="xs"
    >
      <Styles.Container>
        <DialogTitle>
          <Styles.Title>{t`Delete the question ?`}</Styles.Title>
        </DialogTitle>

        <DialogActions>
          <Styles.Actions>
            <PrimaryButton
              destructive
              isLoading={props.isLoading}
              onClick={props.onConfirm}
              disabled={props.isLoading}
            >
              {t`Yes`}
            </PrimaryButton>

            <PrimaryButton
              onClick={props.onClose}
              disabled={props.isLoading}
            >
              {t`No`}
            </PrimaryButton>
          </Styles.Actions>
        </DialogActions>
      </Styles.Container>
    </Dialog>
  )
}

export interface DeleteQuestionDialogProps {
  isLoading?: boolean,
  onClose: () => void,
  onConfirm: () => void | Promise<void>,
}
